export const DETAIL_TRANSACTION = 'DETAIL_TRANSACTION';
export const LIST_TRANSACTION = 'LIST_TRANSACTION';
